import { usedLastScreen } from "../../../../api/actions/user";
import {
  ADD_CONSERVATION,
  ADMIN_DETAIL,
  EDIT_OBJECT,
  EDIT_PHOTOGRAPHY,
} from "../../../../constants/routers";
import { checkPermission } from "../../../../helpers/permissions";

export const redirectBasedOnPermission = ({
  basePath,
  userData,
  userUsedLastScreen,
  navigate, // optional: if you're using React Router
}) => {
  let openUrl = `${basePath}/${ADMIN_DETAIL}`; // default
  let newScreen = null;

  if (
    checkPermission("collection_change_object") &&
    userUsedLastScreen === "Collection"
  ) {
    openUrl = `${basePath}/${EDIT_OBJECT}`;
  } else if (
    checkPermission("photogrophy_change_object") &&
    userUsedLastScreen === "Photography"
  ) {
    openUrl = `${basePath}/${EDIT_PHOTOGRAPHY}`;
  } else if (
    checkPermission("conservation_change_object") &&
    userUsedLastScreen === "Conservation"
  ) {
    openUrl = `${basePath}/${ADD_CONSERVATION}`;
  } else {
    // fallback if last screen not valid
    if (checkPermission("collection_change_object")) {
      openUrl = `${basePath}/${EDIT_OBJECT}`;
      newScreen = "Collection";
    } else if (checkPermission("photogrophy_change_object")) {
      openUrl = `${basePath}/${EDIT_PHOTOGRAPHY}`;
      newScreen = "Photography";
    } else if (checkPermission("conservation_change_object")) {
      openUrl = `${basePath}/${ADD_CONSERVATION}`;
      newScreen = "Conservation";
    }

    const values = {
      museum: userData?.museum,
      screen: newScreen,
    };

    usedLastScreen(values)((response) => {
      localStorage.setItem(
        "user_info",
        JSON.stringify({ ...userData, last_used_screen: newScreen })
      );
    });
  }

  // ✅ Update last used screen if neede

  // ✅ Redirect or return URL
  //   if (navigate) {
  //     navigate(openUrl);
  //   }

  return openUrl;
};
